import { cn } from '#/shared/lib/utils'

/** SVG geometry: a 20-unit box with an 8-radius ring (strokeWidth 2). */
const R = 8
const C = 2 * Math.PI * R

/** Fraction of the ring drawn as the bright arc. */
const ARC = 0.3

/**
 * The voice-input preparing indicator, shown briefly while the mic is granted
 * and the transcription stream opens: a faint full-circle track under one
 * bright arc, the whole ring rotating slowly so it reads as "working". Shared
 * by every mic surface.
 */
export function VoiceLoadingSpinner({ className }: { className?: string }) {
  const arc = C * ARC
  return (
    <span className={cn('inline-flex size-4.5', className)} role="presentation">
      <svg
        viewBox="0 0 20 20"
        className="size-full animate-spin [animation-duration:1.4s]"
      >
        {/* Faint full-circle track — rotates too, but a uniform ring so it reads
            as static. */}
        <circle
          cx="10"
          cy="10"
          r={R}
          fill="none"
          stroke="currentColor"
          strokeOpacity={0.2}
          strokeWidth={2}
        />
        <circle
          cx="10"
          cy="10"
          r={R}
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeDasharray={`${arc} ${C - arc}`}
        />
      </svg>
    </span>
  )
}
